import React, { Component } from 'react'
import Swiper from 'swiper/js/swiper.min'
import 'swiper/css/swiper.min.css'
import './home.css'
import NavArr from '../handf/nav.json'
import SchoolArr from '../handf/school.json'
import Footer from '../handf/Footer'
import { post } from '../../ajax/tools'
import PopUp from '../round/PopUp'
// import wx from "weixin-js-sdk";

// 阿拉伯数字转大写

// let Num = function (num) {
//     if (num === 10) {
//         return '十'
//     } else if (num === 1) {
//         return '一'
//     }
//     const digits = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
//     const units = ['', '十', '百', '千', '万'];
//     let result = '';
//     let numStr = num.toString();
//     for (let i = 0; i < numStr.length; i++) {
//         let digit = parseInt(numStr.charAt(i));
//         let unit = units[numStr.length - i - 1];
//         if (digit === 0) {
//             // 当前数字为0时不需要输出汉字，但需要考虑上一个数字是否为0，避免出现连续的零
//             if (result.charAt(result.length - 1) !== '零') {
//                 result += '零';
//             }
//         } else {
//             result += digits[digit] + unit;
//         }
//     }
//     // 对于一些特殊的数字，如10、100等，需要在最前面加上“一”
//     if (result.charAt(0) === '一') {
//         result = result.substring(1, result.length);
//     } else if (result.charAt(0) === '百') {
//         result = '一' + result;
//     } else if (result.charAt(0) === '千') {
//         result = '一' + result;
//     }
//     return result;
// };

class Home extends Component {
  constructor(props) {
    super(props)
    this.state = {
      CDTArr: [
        {
          id: 1,
          name: '省赛一览',
          url: 'https://oss.asfcyy.com/richTextImage/665b84dce17711f09dcd00163e3521a2.jpg',
          router: '/ss',
        },
        {
          id: 2,
          name: '国赛资讯',
          url: 'http://oss.asfcyy.com/richTextImage/4dc41832e17f11f09dcd00163e3521a2.png',
          router: '/gs',
        },
        {
          id: 3,
          name: '我要参赛',
          url: 'http://oss.asfcyy.com/richTextImage/6d8fba76e18011f09dcd00163e3521a2.jpg',
          router: '/wm',
        },
      ],
      Year: '',
      BannerImageArr: [
        {
          id: 1,
          img_url:
            'https://oss.asfcyy.com/richTextImage/c13f7de4866e11f19dcd00163e3521a2.jpg',
          style: {
            width: '100%',
            height: '100%',
          },
        },
        {
          id: 2,
          img_url:
            'http://oss.asfcyy.com/richTextImage/6a8f0a12e10411ee9dc800163e3521a2.JPG',
          style: {
            position: 'absolute',
            top: '-14%',
            left: '3%',
            transform: 'scale(1.12)',
          },
        },
        {
          id: 3,
          img_url:
            'http://oss.asfcyy.com/richTextImage/0b6bfb1c0f8e11f09dcd00163e3521a2.jpg',
          style: {
            position: 'absolute',
            top: '-14%',
            left: '3%',
            transform: 'scale(1.12)',
          },
        },
        {
          id: 4,
          img_url:
            'http://oss.asfcyy.com/richTextImage/896f8a880f9311f09dcd00163e3521a2.jpg',
          style: {
            position: 'absolute',
            top: '-14%',
            left: '3%',
            transform: 'scale(1.12)',
          },
        },
      ],
    }
  }
  componentDidMount = function () {
    let date = new Date()
    let ToDayYear = date.getFullYear()
    post({
      url: 'match/show_jbs_pro',
      data: {
        match_year: ToDayYear,
        match_type: 1,
      },
    }).then((res) => {
      if (res.errno === '200' && res.data.length !== 0) {
        this.setState({
          Year: ToDayYear,
        })
      } else {
        post({
          url: 'match/show_jbs_pro',
          data: {
            match_year: ToDayYear - 1,
            match_type: 1,
          },
        }).then((res) => {
          if (res.errno === '200' && res.data.length !== 0) {
            this.setState({
              Year: ToDayYear - 1,
            })
          } else {
            this.setState({
              Year: ToDayYear - 1,
            })
          }
        })
      }
    })

    // let compare = function (prop) {
    //     return function (obj1, obj2) {
    //         let val1 = obj1[prop];
    //         let val2 = obj2[prop];
    //         if (val1 < val2){
    //             return 1;
    //         } else if (val1 >val2){
    //             return -1;
    //         } else {
    //             return 0;
    //         }
    //     }
    // };
    // get({url:"a_index/show_img"}).then(res => {
    //     if(res.errno === '200' && res.data.length !== 0){
    //         const BannerImageArr=[];
    //         for(let i=0;i<res.data.length;i++){
    //             const PhotoType = res.data[i].type;
    //             if(PhotoType === 1){
    //                 const BannerImageList = res.data[i];
    //                 BannerImageArr.push(BannerImageList);
    //             }
    //         }
    //         this.setState({
    //             BannerImageArr:BannerImageArr.sort(compare('rank')),
    //         });
    //     }else {
    //         this.setState({
    //             BannerImageArr:[],
    //         });
    //     }
    // });

    let lastScrollTop = 0
    window.addEventListener('scroll', function () {
      const currentScrollTop =
        document.documentElement.scrollTop || document.body.scrollTop
      if (currentScrollTop > lastScrollTop) {
        // console.log('向下滚动');
        document.querySelector('.HomeNavTopBox').dir = 'down'
      } else if (currentScrollTop < lastScrollTop) {
        // console.log('向上滚动');
        document.querySelector('.HomeNavTopBox').dir = 'up'
      }
      lastScrollTop = currentScrollTop
    })

    let a = document.querySelector('.HomeBannerBox').clientHeight
    let b = document.documentElement.clientHeight
    if (a >= b) {
      document.querySelector('.HomeBgICo').style.position = 'fixed'
    } else {
      document.querySelector('.HomeBgICo').style.position = 'absolute'
    }
    window.onscroll = function () {
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop
      // console.log("滚动距离" + scrollTop);
      if (document.querySelector('.HomeBgICo')) {
        if (a >= b) {
          if (b >= a - scrollTop) {
            document.querySelector('.HomeBgICo').style.position = 'absolute'
          } else {
            document.querySelector('.HomeBgICo').style.position = 'fixed'
          }
        }
        // if (scrollTop > 0){
        //     document.querySelector('.HomeNavTopBox').className = 'HomeNavTopBox NavBoxTow';
        // }else {
        //     document.querySelector('.HomeNavTopBox').className = 'HomeNavTopBox';
        // }
        if (scrollTop !== 0) {
          document.querySelector('.HomeNavTopBox').style.boxShadow = 'none'
        } else {
          document.querySelector('.HomeNavTopBox').style.boxShadow =
            '-10px 50px 70px 80px rgba(0, 0, 0, 0.4)'
        }
      }
    }
  }

  componentDidUpdate() {
    this.swiper = new Swiper('.swiper-container', {
      loop: true, //循环
      slidesPerView: 1, //展示几个
      freeMode: true,
      centeredSlides: true, //设置了Active Slide居中
      centeredSlidesBounds: true, //第一个和最后一个Slide 始终贴合边缘
      // width : 'auto', //你的slide宽度
      // height: 'auto',//你的slide高度
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      autoplay: {
        delay: 4000, // 自动切换间隔时间
        disableOnInteraction: false, //操作Swiper是否停止autoplay
      },
      speed: 800, //切换速度，即slider自动滑动开始到结束的时间
    })
  }

  UNSAFE_componentWillUpdate() {
    if (this.swiper) {
      this.swiper.destroy()
    }
  }

  NavListClick = (item, index) => {
    if (item.name === '官网首页') {
      window.location.href = 'https://www.asfcyy.com'
    } else {
      const { history } = this.props
      history.push(item.router)
    }
  }

  CDTClick = (item, index) => {
    const { history } = this.props
    history.push(item.router)
  }

  JoinGame() {
    const { history } = this.props
    history.push('/yj')
  }

  YJMore() {
    const { history } = this.props
    history.push('/yj')
  }

  //提示弹窗
  ChildBackTip = (event) => {
    if (event === 'CrossOut') {
      this.setState({
        PopUp: '',
      })
    }
  }

  render() {
    // console.log(this.state.BannerImageArr)
    return (
      <div className={'Home'}>
        {/*菜单*/}
        <div
          className={'HomeNavTopBox'}
          style={{ boxShadow: '-10px 50px 70px 80px rgba(0, 0, 0, 0.4)' }}
        >
          <div className={'NavTopBox'}>
            <div className={'HomeLogoBox'}>
              <img
                className={'HomeLogo'}
                src="http://oss.asfcyy.com/richTextImage/616aeb76dee911ee9dc800163e3521a2.png"
                alt=""
              />
            </div>
            <div className={'NavTop clearfix'}>
              {NavArr.map((item, index) => (
                <div
                  className={'NavTopList'}
                  key={index}
                  onClick={() => this.NavListClick(item, index)}
                >
                  {item.name}
                </div>
              ))}
            </div>
          </div>
        </div>
        {/*主图或轮播*/}
        <div className={'HomeBannerBox'}>
          <div className={'HomeBannerBg'}> </div>
          <div id={'HomeBanner'}>
            <div className={'swiper-container'}>
              <div className={'swiper-wrapper swiper-no-swiping'}>
                {this.state.BannerImageArr.map((item, index) => (
                  <div className={'swiper-slide'} key={index}>
                    <img
                      className={'BannerImage'}
                      src={item.img_url}
                      alt={''}
                      style={item.style}
                    />
                  </div>
                ))}
              </div>
            </div>
            <div>
              <div className="swiper-button-next">
                <div className={'nextIco'}> </div>
              </div>
              <div className="swiper-button-prev">
                <div className={'nextIco'}> </div>
              </div>
            </div>
          </div>
          <div className={'HomeBgBox'}>
            {this.state.Year !== '' && (
              <div>
                <div
                  className={'HomeBgTit'}
                  style={{ marginTop: '10.55556vw' }}
                >
                  {new Date().getFullYear() - 1} - {new Date().getFullYear()}
                  学年
                </div>
                {/*<div className={'HomeBgTit'} style={{marginTop:'10.55556vw',}}>第{Num(this.state.Year-2009)}届</div>*/}
                <div className={'HomeBgTit'}>全国青少年模拟飞行锦标赛</div>
                <div className={'HomeBgWord'}> </div>
                <div className={'HomeBgBtn'} onClick={this.JoinGame.bind(this)}>
                  <div className={'HomeBgBtnIco'}> </div>
                  查看更多
                </div>
              </div>
            )}
            <div className={'HomeBgICo'}> </div>
          </div>
        </div>

        {/*愿景*/}
        <div className={'YJ'}>
          <div className={'YJBox'}>
            <div className={'YJImgBox'}>
              <img
                className={'YJImg'}
                src="https://oss.asfcyy.com/richTextImage/c13f7de4866e11f19dcd00163e3521a2.jpg"
                alt=""
              />
            </div>
            <div className={'YJWordBox'}>
              <div className={'YJWordTit'}>赛事愿景</div>
              <div className={'YJWordBor'}> </div>
              <div className={'YJWord1'}>全国青少年模拟飞行锦标赛</div>
              <div className={'YJWord2'}>
                ——多年来为中国航空事业培养大批人才
              </div>
              <div className={'YJWord3'}>
                深刻贯彻"体育是教育重要组成，教育是体育主要功能"的体教融合理念。
              </div>
              <div className={'YJBtn'} onClick={this.YJMore.bind(this)}>
                <div className={'YJBtnIco'}> </div>
                <div className={'YJBtnBor'}> </div>
                <div className={'YJBtnWord'}>查看更多</div>
              </div>
            </div>
          </div>
        </div>

        {/*菜单图*/}
        <div className={'CDT'}>
          <div className={'CDTBox'}>
            {this.state.CDTArr.map((item, index) => (
              <div
                className={'CDTBoxListBox'}
                key={index}
                onClick={() => this.CDTClick(item, index)}
              >
                <div className={'CDTBoxListImg'}>
                  <img className={'YJImg'} src={item.url} alt="" />
                </div>
                <div className={'CDTBoxListBtn'}>{item.name}</div>
              </div>
            ))}
          </div>
        </div>

        {/*鸿鹄高飞 一举千里*/}
        <div className={'HY'}>
          <div className={'HYBox'}>
            <div className={'HYBoxTit'}>鸿鹄高飞 一举千里</div>
            <div className={'HYBoxConBox'}>
              <div className={'HYBoxConD'}> </div>
              <div className={'HYBoxConH'}> </div>
              <div className={'HYBoxConQ1'}>
                <div
                  className={'HYBoxWordBox'}
                  style={{ width: 350, left: -378 }}
                >
                  <div className={'HYBoxWord1'}>
                    全国唯一的青少年模拟飞行锦标赛
                  </div>
                  <div className={'HYBoxNum'}>1</div>
                  <div className={'triangle'}> </div>
                </div>
              </div>
              <div className={'HYBoxConQ2'}>
                <div
                  className={'HYBoxWordBox'}
                  style={{ width: 487, left: 78, height: 112 }}
                >
                  <div className={'HYBoxWord2'} style={{ top: 14, left: 80 }}>
                    依据中国航空运动协会《模拟飞行技能等级划分与
                  </div>
                  <div className={'HYBoxWord2'} style={{ top: 42, left: 80 }}>
                    评定》(T/ASFC 1010-2023)、《模拟飞行场地规
                  </div>
                  <div className={'HYBoxWord2'} style={{ top: 72, left: 80 }}>
                    范》(T/ASFC 1012-2023)两项团体标准举办
                  </div>
                  <div
                    className={'HYBoxNum'}
                    style={{ right: 'unset', left: 20, lineHeight: '114px' }}
                  >
                    2
                  </div>
                  <div className={'triangle1'}> </div>
                </div>
              </div>
              <div className={'HYBoxConQ3'}>
                <div
                  className={'HYBoxWordBox'}
                  style={{ width: 513, left: -535 }}
                >
                  <div className={'HYBoxWord2'} style={{ top: 14 }}>
                    教育部批准，国家体育总局航管中心、中国航空运动
                  </div>
                  <div className={'HYBoxWord2'} style={{ top: 42 }}>
                    协会主办，中国民用航空局、空军招飞局共同支持
                  </div>
                  <div className={'HYBoxNum'}>5</div>
                  <div className={'triangle'}> </div>
                </div>
              </div>
              <div className={'HYBoxConQ4'}>
                <div
                  className={'HYBoxWordBox'}
                  style={{ width: 417, left: 78 }}
                >
                  <div
                    className={'HYBoxWord1'}
                    style={{
                      left: 'unset',
                      right: 23,
                      width: 274,
                      textAlign: 'left',
                      top: 15,
                    }}
                  >
                    覆盖全国32个省、自治区、直辖市中小学校内和校外
                  </div>
                  <div
                    className={'HYBoxNum'}
                    style={{ right: 'unset', left: 20 }}
                  >
                    32
                  </div>
                  <div className={'triangle1'}> </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/*学校标题*/}
        <div className={'SchoolTit'} style={{ marginTop: 93 }}>
          模拟飞行开启航空知识宝库
        </div>
        <div className={'SchoolTit'}>中国参与模拟飞行运动的著名院校</div>
        <div className={'SchoolImg'}>
          <div className={'SchoolImgBox'}>
            {SchoolArr.map((item, index) => (
              <div className={'SchoolListBox'} key={index}>
                <img src={item.url} alt="" />
              </div>
            ))}
          </div>
        </div>

        <Footer />
        {this.state.PopUp === '提示弹窗' && (
          <PopUp
            ChildBackClick={this.ChildBackTip.bind(this)}
            type={'提示'}
            message={this.state.MessageTip}
            OutButton={'Yes'}
          />
        )}
      </div>
    )
  }
}

export default Home
